import { render } from "./about-license-tab.vue?vue&type=template&id=3e8761c8&ts=true"
import script from "./about-license-tab.vue?vue&type=script&lang=ts"
export * from "./about-license-tab.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__